"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAuthenticationService = void 0;
/* istanbul ignore file */
const auth0_js_1 = __importDefault(require("auth0-js"));
const __1 = require("..");
const domain_1 = require("../../../domain");
const mappers_1 = require("../mappers");
const lodash_1 = __importDefault(require("lodash"));
let auth0;
class FAuthenticationService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    deleteAccount(input) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.apolloClient.mutate({
                    mutation: __1.DELETE_USER_ACCOUNT,
                    variables: input,
                });
                return Promise.resolve(response);
            }
            catch (error) {
                return Promise.reject(new domain_1.AuthenticationServiceErrors.DeleteAccountRequestError("DELETE_ACCOUNT_REQUEST_FAILED", error));
            }
        });
    }
    initializeAuth0Client(config) {
        auth0 = new auth0_js_1.default.WebAuth({
            audience: config.AUTH0_WEB_AUDIENCE,
            clientID: config.AUTH0_WEB_CLIENT_ID,
            domain: config.AUTH0_WEB_DOMAIN,
            redirectUri: config.POINTAGE ? `${config.WEB_BASE_URL}/callback` : `${config.WEB_BASE_URL}/authentication-callback`,
            responseType: config.AUTH0_WEB_RESPONSE_TYPE,
        });
    }
    login(config) {
        try {
            auth0.authorize({
                prompt: config.AUTH0_APP_PROMPT,
                redirectUri: config.POINTAGE ? `${config.WEB_BASE_URL}/callback` : `${config.WEB_BASE_URL}/authentication-callback`,
            });
        }
        catch (error) {
            throw new domain_1.AuthenticationServiceErrors.LoginRequestError("LOGIN_REQUEST_FAILED", error);
        }
    }
    retrieveTokens({ authResultCallBack, authErrorCallback, }) {
        auth0.parseHash((error, authResult) => {
            if (authResult) {
                authResultCallBack(authResult);
            }
            else if (error) {
                authErrorCallback(error);
            }
        });
    }
    refreshToken() {
        return new Promise(
        // @ts-ignore
        (resolve, reject) => {
            auth0.checkSession({
                state: undefined,
            }, (err, result) => {
                if (err) {
                    reject(err);
                }
                resolve(new Response(JSON.stringify(result)));
            });
        });
    }
    checkEmail(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const checkEmailMapper = new mappers_1.CheckEmailMapper();
            try {
                const response = yield this.apolloClient.query({
                    query: __1.CHECK_EMAIL,
                    variables,
                    fetchPolicy: "network-only",
                });
                return Promise.resolve(checkEmailMapper.toDomain(response));
            }
            catch (error) {
                return Promise.reject(new domain_1.AuthenticationServiceErrors.CheckEmailRequestError("CHECK_EMAIL_REQUEST_FAILED", error));
            }
        });
    }
    signUp(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            const signUpMapper = new mappers_1.SignUpMapper();
            try {
                const response = yield this.apolloClient.mutate({
                    mutation: __1.SIGNUP,
                    variables,
                });
                return Promise.resolve(signUpMapper.toDomain(response));
            }
            catch (error) {
                const errorMessage = lodash_1.default.get(error, "graphQLErrors[0].extensions.original.details[0].message");
                if (errorMessage === "The associated ressource was not found") {
                    return {
                        hasError: true,
                        errorMessage,
                    };
                }
                return Promise.reject(new domain_1.AuthenticationServiceErrors.SignUpRequestError("SIGNUP_REQUEST_FAILED", error));
            }
        });
    }
    loginSSO(config) {
        try {
            auth0.authorize({
                prompt: config.AUTH0_APP_PROMPT,
                login_hint: config.email,
                redirectUri: `${config.WEB_BASE_URL}/authentication-callback`,
                state: "sso",
            });
        }
        catch (error) {
            throw new domain_1.AuthenticationServiceErrors.LoginRequestError("LOGIN_SSO_REQUEST_FAILED", error);
        }
    }
    loginIDP(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const idpSSOMapper = new mappers_1.IDPSSOMapper();
            try {
                const response = yield this.apolloClient.mutate({
                    mutation: __1.IDP_SSO,
                    variables: { input: { code } },
                });
                return Promise.resolve(idpSSOMapper.toDomain(response));
            }
            catch (error) {
                throw new domain_1.AuthenticationServiceErrors.LoginRequestError("LOGIN_IDP_REQUEST_FAILED", error);
            }
        });
    }
    sendResetPasswordEmail(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseURL = `https://${request.AUTH0_WEB_DOMAIN}/${request.AUTH0_WEB_RESET_PASSWORD}`;
            const body = {
                client_id: request.AUTH0_WEB_CLIENT_ID,
                email: request.email,
                connection: request.AUTH0_WEB_CONNECTION,
            };
            try {
                const response = yield window.fetch(baseURL, {
                    method: "post",
                    headers: {
                        Accept: "application/json, text/json, */*",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(body),
                });
                if (response.status !== 200) {
                    throw Error;
                }
                return Promise.resolve(response.status);
            }
            catch (error) {
                return Promise.reject(new domain_1.AuthenticationServiceErrors.SendResetPasswordEmail("SEND_RESET_PASSWORD_EMAIL_ERROR", error));
            }
        });
    }
}
exports.FAuthenticationService = FAuthenticationService;
